import { Context } from '@nuxt/types';
import { findExternalEnrollmentPath, ExternalEnrollmentSettings } from '~/services/externalEnrollment';

/**
 * Guards the routes whose enrollment moved to togetherwithgsk.com. Anything under /patient or
 * /hcp is unreachable in this portal now, however it was reached: typed URL, bookmark, back
 * button, or a leftover in-app link.
 *
 * Nuxt's redirect() sends absolute URLs through window.location.assign() and aborts the pending
 * route, so the guarded page never renders.
 */
export default function({ route, redirect, env }: Context) {
    const match = findExternalEnrollmentPath(route.path);
    if (!match) {
        return;
    }

    // Fall back to the landing page rather than leaving the route open if the URL is ever unset.
    redirect((env as ExternalEnrollmentSettings)[match.settingsKey] || '/');
}
